<template>
<div class="page_pay">
    <!-- 绑微信提醒 -->
    <div class="wechat_tips" v-if="!bindWX" @click="bandwechat">
        <div class="tips_left">请绑定微信</div>
        <div class="tips_right">
            <img :src="publicPath+'statics/images/weixin-2.png'" alt="" class="icon_wechat">
            <img :src="publicPath+'statics/images/icon_right_grey.png'" alt="" class="icon_right">
        </div>
    </div>
    <!-- 订单信息 -->
    <div class="order">
        <div class="order_tips">订单已提交</div>
        <div class="order_number">支付订单号：{{ orderId }}</div>
    </div>
    <!-- 支付方式 -->
    <div class="payList">
        <van-radio-group v-model="checkedPay">
            <van-cell-group>
                <van-cell class="item" v-for="(item,index) in payMent" :key="index" @click="FunCheckPay(item)">
                    <template #title>
                        <img :src="item.icon" alt="" class="tu">
                        <span class="title">{{item.name}}</span>
                    </template>
                    <template #right-icon>
                        <van-radio :name="item.id" :disabled="item.status ? false : true">
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon">
                            </template>
                        </van-radio>
                    </template>
                </van-cell>
            </van-cell-group>
        </van-radio-group>
    </div>
    <div class="action">
        <div class="pay" @click="tijiao">立即支付¥{{ price }}</div>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    // name: "map-index",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            orderId: null,
            price: null,
            isPlatprice: 0,
            token: null,
            useraccount: {},
            activeIcon: process.env.BASE_URL + 'statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + 'statics/images/inactive.png',
            selectPayItem: null,
            selectPayPlatId: null,
            payMent: [{
                id: 1,
                name: '微信支付',
                pay: 'weixin',
                icon: process.env.BASE_URL + 'statics/images/shop/icon_wechat.png',
                status: 1
            }, ],
            checkedPay: null,
            activeIcon_plat: process.env.BASE_URL + 'statics/images/active_square.png',
            inactiveIcon_plat: process.env.BASE_URL + 'statics/images/inactive_square.png',
            bindWX: false // 是否绑定微信
        };
    },
    components: {
        // PageSearch
    },
    created: function () {
        this.orderId = this.$route.query.orderId;
        this.price = this.$route.query.price;
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '支付'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            console.log('sdjy://member/memberInfo')
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getUserData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
                
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
            this.getUserData()
        }
    },
    methods: {
        //提交支付
        tijiao() {
            if (this.selectPayItem == null ) {
                this.$toast('请选择支付方式')
                return
            }
			var that = this
            var params = {
                token: this.$store.getters.token,
                order_num: this.orderId,
            }
            console.log(this.selectPayItem.pay)
            // return;
            this.$api.living.payVideoOrder(params).then(res => {
                if (res.code == 200) {
                    if (that.selectPayItem && that.selectPayItem.pay == 'weixin') {
                        var data = res.result;
                        // 配置微信config
                        wx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: data.config.appId, // 必填，公众号的唯一标识
                            timestamp: data.config.timeStamp, // 必填，生成签名的时间戳
                            nonceStr: data.config.nonceStr, // 必填，生成签名的随机串
                            signature: data.config.paySign, // 必填，签名，见附录1
                            jsApiList: ["chooseWXPay"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                        });
                        wx.ready(function () {
                            // 调起微信支付
                            wx.chooseWXPay({
                                timestamp: data.config.timeStamp,
                                nonceStr: data.config.nonceStr,
                                package: data.config.package,
                                signType: data.config.signType,
                                paySign: data.config.paySign, // 支付签名
                                success: function (res) {
                                    console.log('success')
                                    console.log(res)
                                    // 支付成功，转到订单列表页面
                                    if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                                        var params = {
                                            'data': {
                                                'url': that.$publicData.clientUrl + '/pay/success?type=video' 
                                            }
                                        }
                                        that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                                        })
                                    } else {
                                        that.$router.push({
                                            path: '/pay/success',
                                            type: 'video'
                                        })
                                    }
                                },
                                error: function (res) {

                                },
                                cancel: function (res) {

                                }
                            });
						});
						// 配置失败返回
                        wx.error(function (res) {
                            // that.$toast("微信支付配置失败！");
							// that.loading = false;
							console.log('error')
                            console.log(res)
                            // setTimeout(function () {
                            //     location.href = "{{ url('pay',['oid'=>$oid]) }}";
                            // }, 2000);
                        });
                    } else {
                        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                            var params = {
                                'data': {
                                    'url': this.$publicData.clientUrl + '/pay/success?type=video'
                                }
                            }
                            this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                            })
                        } else {
                            this.$router.push({
                                path: '/pay/success',
                                type: 'video'
                            })
                        }
                    }
                    // this.dataList = res.result
                } else {
                    this.$toast(res.message)
                }
            })

        },
        // 选中支付方式 第三方如微信、支付宝、银行卡等‘单选’
        FunCheckPay(item) {
            console.log(item.id)
            this.selectPayItem = item
            if (!item.status) {
                this.$toast('暂不支持，该支付方式！');
            }
        },
        // 选中支付方式 平台余额、充值卡等 ‘可多选’
        FunCheckPayPlat(id) {
            this.selectPayPlatId = id
            console.log(id)
        },
        FunCheckCardPayPlat(id) {
            this.selectPayCardPlatId = id
            console.log(id)
        },
        // 获取用户信息
        getUserData() {
            if (this.token == null) {
                return
            }
            var params = {
                token: this.token
            }
            this.$api.user.index(params).then(res => {
                if (res.code == 200) {
                    if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                        if (res.result.info.users.app_openid && res.result.info.users.app_openid != undefined && res.result.info.users.app_openid != '') {
                            this.bindWX = true
                        } else {
                            this.bindWX = false
                        }
                    } else {
                        if (res.result.info.users.openid && res.result.info.users.openid != undefined && res.result.info.users.openid != '') {
                            this.bindWX = true
                        } else {
                            this.bindWX = false
                        }
                    }
                }
            })
        },
        // 绑定微信
        bandwechat() {
            this.$router.push({
                path: '/set/account'
            })
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
